import React from "react";
import PropTypes from "prop-types";
import HelperText from "../../../../../components/atoms/HelperText";
import GnomadEntry from "../GnomadEntry";

function GnomadExplanation({ gnomadEntry }) {
  if (!gnomadEntry) return null;
  if (!gnomadEntry.constraintFlags?.length) return null;

  return (
    <div className="varsome-horiz-flex">
      <div className="varsome-horiz-list-item">
        <div className="varsome-horiz-list-label">
          Constraint Flag <HelperText fieldDescriptionKey="Constraint Flag" />
        </div>
        <div className="varsome-horiz-list-value">
          {gnomadEntry.constraintFlags
            .map((x) => x?.flag)
            .filter(Boolean)
            .join("\n")}
        </div>
      </div>
      <div className="varsome-horiz-list-item">
        <div className="varsome-horiz-list-label">Explanation</div>
        <div className="varsome-horiz-list-value">
          {gnomadEntry.constraintFlags
            .map((x) => x?.explanation)
            .filter(Boolean)
            .join("\n")}
        </div>
      </div>
    </div>
  );
}

GnomadExplanation.propTypes = {
  gnomadEntry: PropTypes.instanceOf(GnomadEntry),
};

GnomadExplanation.defaultProps = {
  gnomadEntry: null,
};

export default React.memo(GnomadExplanation);
